
declare var Object: any;
export interface FacilityViewInterface {
  "id": number;
  "contactId"?: number;
  "status": string;
  "legalName": string;
  "name": string;
  "shortname": string;
  "type": string;
  "timezoneOffset"?: number;
  "geotabZoneId"?: string;
  "notes"?: string;
  "data": any;
  "ctime": Date;
  "utime": Date;
  "dtime"?: Date;
  "dtime_str"?: string;
  "typeOrder": number;
  "contact_id"?: number;
  "contact_notes"?: string;
  "contact_addresses_0_id"?: string;
  "contact_addresses_0_street"?: string;
  "contact_addresses_0_city"?: string;
  "contact_addresses_0_state"?: string;
  "contact_addresses_0_zip"?: string;
  "contact_phones_0_id"?: string;
  "contact_phones_0_value"?: string;
  "contact_emails_0_id"?: string;
  "contact_emails_0_value"?: string;
}

export class FacilityView implements FacilityViewInterface {
  "id": number;
  "contactId": number;
  "status": string;
  "legalName": string;
  "name": string;
  "shortname": string;
  "type": string;
  "timezoneOffset": number;
  "geotabZoneId": string;
  "notes": string;
  "data": any;
  "ctime": Date;
  "utime": Date;
  "dtime": Date;
  "dtime_str": string;
  "typeOrder": number;
  "contact_id": number;
  "contact_notes": string;
  "contact_addresses_0_id": string;
  "contact_addresses_0_street": string;
  "contact_addresses_0_city": string;
  "contact_addresses_0_state": string;
  "contact_addresses_0_zip": string;
  "contact_phones_0_id": string;
  "contact_phones_0_value": string;
  "contact_emails_0_id": string;
  "contact_emails_0_value": string;
  constructor(data?: FacilityViewInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `FacilityView`.
   */
  public static getModelName() {
    return "FacilityView";
  }

  /**
  * This method creates an instance of FacilityView for dynamic purposes.
  **/
  public static factory(data: FacilityViewInterface): FacilityView{
    return new FacilityView(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FacilityView',
      plural: 'FacilityViews',
      path: 'FacilityViews',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "contactId": {
          name: 'contactId',
          type: 'number'
        },
        "status": {
          name: 'status',
          type: 'string'
        },
        "legalName": {
          name: 'legalName',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "shortname": {
          name: 'shortname',
          type: 'string'
        },
        "type": {
          name: 'type',
          type: 'string'
        },
        "timezoneOffset": {
          name: 'timezoneOffset',
          type: 'number'
        },
        "geotabZoneId": {
          name: 'geotabZoneId',
          type: 'string'
        },
        "notes": {
          name: 'notes',
          type: 'string'
        },
        "data": {
          name: 'data',
          type: 'any'
        },
        "ctime": {
          name: 'ctime',
          type: 'Date'
        },
        "utime": {
          name: 'utime',
          type: 'Date'
        },
        "dtime": {
          name: 'dtime',
          type: 'Date'
        },
        "dtime_str": {
          name: 'dtime_str',
          type: 'string'
        },
        "typeOrder": {
          name: 'typeOrder',
          type: 'number'
        },
        "contact_id": {
          name: 'contact_id',
          type: 'number'
        },
        "contact_notes": {
          name: 'contact_notes',
          type: 'string'
        },
        "contact_addresses_0_id": {
          name: 'contact_addresses_0_id',
          type: 'string'
        },
        "contact_addresses_0_street": {
          name: 'contact_addresses_0_street',
          type: 'string'
        },
        "contact_addresses_0_city": {
          name: 'contact_addresses_0_city',
          type: 'string'
        },
        "contact_addresses_0_state": {
          name: 'contact_addresses_0_state',
          type: 'string'
        },
        "contact_addresses_0_zip": {
          name: 'contact_addresses_0_zip',
          type: 'string'
        },
        "contact_phones_0_id": {
          name: 'contact_phones_0_id',
          type: 'string'
        },
        "contact_phones_0_value": {
          name: 'contact_phones_0_value',
          type: 'string'
        },
        "contact_emails_0_id": {
          name: 'contact_emails_0_id',
          type: 'string'
        },
        "contact_emails_0_value": {
          name: 'contact_emails_0_value',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}
